module.exports = "pegasus/assets/theme4/small/5.jpg";